// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b83fc319","455":"48a0461c","977":"5bc9ca7a"}[chunkId] + ".chunk.js";
};